import { useContext } from 'react';
import { useStore } from 'zustand';
import type { AiAssistPromptsEditorStateStore } from '@web-config-app/core';
import { AiAssistPromptsEditorStateStoreContext } from '../../providers/ai-assist-prompts-editor-state-store-provider/ai-assist-prompts-editor-state-store-provider.component';

export function useAiAssistPromptsEditorStateStore<T>(
  selector: (state: AiAssistPromptsEditorStateStore) => T,
): T {
  const aiAssistPromptsEditorStateStoreContext = useContext(
    AiAssistPromptsEditorStateStoreContext,
  );
  if (!aiAssistPromptsEditorStateStoreContext) {
    throw new Error(
      'useAiAssistPromptsEditorStateStore must be used within the AiAssistPromptsEditorStateStoreProvider',
    );
  }
  return useStore(aiAssistPromptsEditorStateStoreContext, selector);
}
